import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '../button';
import { Typography } from '../typography';
import HtmlContent from '../htmlContent/HtmlContent';
import { Image } from '../Image/Image';

// Interface

export interface SpecialOfferProps {
  logo: { key: string };
  heading: string;
  description: string;
  link: string;
}

// Styles

const StyledSpecialOffer = styled.div`
  ${({ theme: { colors, space, media } }) => css`
    border-top: solid 1px ${colors.neutralMidGrey};

    display: flex;
    flex-direction: column;
    padding: ${space.large} 0 0 0;

    & + & {
      border-bottom: solid 1px ${colors.neutralMidGrey};
      padding-bottom: ${space.large};
    }

    @media (min-width: ${media.medium}) {
      flex-direction: row;
      gap: ${space.medium};
    }
  `};
`;

const StyledImage = styled.div`
  ${({ theme: { media, space } }) => css`
    margin-bottom: ${space.small};

    @media (min-width: ${media.medium}) {
      margin-bottom: 0;
      min-width: 180px;
    }
  `};
`;

const StyledContent = styled.div`
  ${({ theme: { space, media } }) => css`
    margin-bottom: ${space.small};

    @media (min-width: ${media.medium}) {
      margin-bottom: 0;
    }
  `};
`;

const StyledTitle = styled(Typography)`
  ${({ theme: { colors, space } }) => css`
    color: ${colors.brandOne100};
    margin-bottom: ${space.xSmall};
  `};
`;

const StyledCTA = styled(Button)`
  ${({ theme: { media } }) => css`
    /* width: 100%; */

    @media (min-width: ${media.medium}) {
      min-width: 250px;
      display: inline-flex;
      justify-self: flex-start;
      align-self: flex-start;
    }
  `};
`;

// JSX

export const SpecialOffer: FC<SpecialOfferProps> = ({
  logo,
  heading,
  description,
  link,
}) => {
  const url = link?.url || null;

  return (
    <StyledSpecialOffer>
      <StyledImage>
        <Image src={logo?.image?.localFile} alt={heading} loading="eager" />
      </StyledImage>
      <StyledContent>
        <StyledTitle component="h3" variant="headingMedium">
          {heading}
        </StyledTitle>
        <HtmlContent>{description}</HtmlContent>
      </StyledContent>
      {url && (
        <StyledCTA variant="primary" url={url} label={link.label || url} />
      )}
    </StyledSpecialOffer>
  );
};

export default SpecialOffer;
